<template src="./countries.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TopMenu from "@/components/settings/components/topMenu"
import ClientCountrySelect from '@/components/components/ClientCountrySelect';

const { mapGetters, mapActions} = createNamespacedHelpers('settings/countries');

export default {
  name: "countries",
  components: {
    TopMenu,
    ClientCountrySelect,
  },
  data () {
    return {
      showOverlay: false,
      editSwitch: false,
      isReady: false,
      isChange: false,
      fieldsList: [
        {
          key: 'id',
          label: '-',
          sortable: false,
          tdClass: 'action-cell',
          thClass: 'action-cell'
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true
        },
      ],
      reComputed: false,
      renderComponent: true,
      searchVal: '',
    }
  },
  computed: {
    ...mapGetters([
      'COUNTRIES',
    ]),
  },
  methods: {
    ...mapActions([
      'GET_DATA',
    ])
  },
  watch: {
  },
  mounted() {
    this.GET_DATA({th: this});
  },
  created() {
  }
}
</script>

<style scoped>
.country-view {
  cursor: pointer;
}
.demand-countries .container-fluid {
  padding: 0;
}
.col-but-add {
  text-align: left;
}
.select-height {
  height: 27px;
}

</style>

<style>
.demand-countries  .multiselect__select, .demand-countries  .multiselect__tags {
  min-height: 30px;
  height: 33px;
}
.demand-countries .multiselect__placeholder {
  line-height: 16px;
}
</style>